import Swiper from 'swiper';
import 'swiper/css/swiper.css';
export default {
  data() {
    return {
      initialDistance: 0,
      baseWidth: 100,
      imageWidth: 100,
      scaleNum: 1
    };
  },
  props: ['imgs', 'noSwiper'],
  methods: {
    onTouchStart(event) {
      if (event.touches.length === 2) {
        this.initialDistance = Math.hypot(event.touches[0].pageX - event.touches[1].pageX, event.touches[0].pageY - event.touches[1].pageY);
      }
    },
    onTouchMove(event) {
      if (event.touches.length === 2) {
        const currentDistance = Math.hypot(event.touches[0].pageX - event.touches[1].pageX, event.touches[0].pageY - event.touches[1].pageY);
        console.log(currentDistance, this.initialDistance);
        if (currentDistance > this.initialDistance) {
          // 放大图片
          if (this.scaleNum >= 2) return;
          this.scaleNum += 0.1;
        } else if (currentDistance < this.initialDistance) {
          // 缩小图片，可添加边界条件判断防止过小
          if (this.scaleNum <= 1) return;
          this.scaleNum -= 0.1;
        }
        this.initialDistance = currentDistance;
      }
    },
    onTouchEnd() {
      this.initialDistance = 0;
    }
  },
  mounted() {
    if (this.noSwiper) return;
    this.$nextTick(() => {
      new Swiper(this.$refs.swiperBigImg, {
        pagination: {
          el: '.swiper-pagination'
        },
        slidesPerView: 'auto',
        initialSlide: 0,
        centeredSlides: true,
        runCallbacksOnInit: false,
        touchMoveStopPropagation: true,
        slideToClickedSlide: true,
        observer: true,
        observeSlideChildren: true
      });
    });
  },
  created() {
    console.log(this.imgs);
  },
  computed: {}
};